import { render, staticRenderFns } from "./specificationManage.vue?vue&type=template&id=16048397&"
import script from "./specificationManage.vue?vue&type=script&lang=js&"
export * from "./specificationManage.vue?vue&type=script&lang=js&"
import style0 from "./specificationManage.vue?vue&type=style&index=0&id=16048397&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports